var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDarkmodeActivestate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.48143 7.26719C0.447618 10.8883 0.843087 15.1012 5.02124 18.699C8.44495 21.6472 12.654 21.3239 15.6987 20.1498C19.5896 18.6492 20.9213 14.695 20.9213 14.695C20.9213 14.695 17.8784 15.6783 14.8862 15.4494C12.5406 15.2698 10.338 14.1345 8.90922 12.6059C7.69824 11.3103 6.63936 8.92626 6.47195 6.91901C6.20763 3.74974 7.34242 1 7.34242 1C7.34242 1 2.70779 2.97161 1.48143 7.26719Z",
    fill: "#747474",
    stroke: "#747474",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkmodeActivestate);
export default __webpack_public_path__ + "static/media/Dark mode _ active state.b140a411174f77c6d9418f1d58811943.svg";
export { ForwardRef as ReactComponent };